import { apiSlice } from "../../app/api/apiSlice";

import { setCurrentUserName } from "../verify/verifySlice";

export const signupApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    signup: builder.mutation({
      query: (formData) => ({
        url: "/register",
        method: "POST",
        body: { ...formData },
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          const { verifyUserName } = data;

          dispatch(setCurrentUserName({ username: verifyUserName }));
        } catch (err) {
          console.error(err);
        }
      },
    }),
  }),
});

export const { useSignupMutation } = signupApiSlice;
